import * as metaStateUtils from '../../../../store/util/metaStateUtils';


export default (state, globalConfigState, isLoading) => {

    // let globalConfigState = fromJS(config).delete('contentDepartments');
    globalConfigState = isLoading
        ? metaStateUtils.setIsLoading(globalConfigState)
        : metaStateUtils.setIsLoaded(globalConfigState);
    state.global = globalConfigState;

    return state;
};
